<div class="modal-header email-preview-dialog">
    <h5 class="modal-title" translate>Request.Status.EditData</h5>
</div>
<div class="modal-body email-preview-dialog">
    
    <div class="row row-cols-12 row-cols-sm-12 row-cols-md-12 row-cols-lg-12 row-cols-xl-12">
        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-truncate">
            <input type="text" class="form-control edit" (keyup)="PersonChange('firstname',$event)" value="{{actor.firstname}}" placeholder="">
        </div>
        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-truncate">
            <input type="text" class="form-control edit" (keyup)="PersonChange('prefix',$event)" value="{{actor.prefix}}" placeholder="">
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-truncate">
            <input type="text" class="form-control edit" (keyup)="PersonChange('lastname',$event)" value="{{actor.lastname}}" placeholder="">
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-truncate">
            <input type="text" class="form-control edit" (keyup)="PersonChange('email',$event)" value="{{actor.email}}" placeholder="">
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-truncate">
            <textarea rows="3" class="form-control edit" (keyup)="PersonChange('message',$event)" value="{{originalMessage}}" placeholder=""></textarea>
        </div>
        <div class="input-group col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <input class="form-control edit position-relative top--20" placeholder="{{placeholderDate}}" name="dp" [(ngModel)]="model" ngbDatepicker #d="ngbDatepicker" [minDate]="startDate" [startDate]="startDate" (click)="d.toggle()" (ngModelChange)="PersonChange('deadline',$event)" aria-describedby="basic-addon1">
            <span class="input-group-text deadline edit " id="basic-addon1">
                <em class="bi bi-calendar" (click)="d.toggle()" aria-hidden="true"></em>
            </span>
        </div>
    </div>
</div>
<div class="modal-footer d-block dialog-footer-height">
    <div class="float-start">
        <button class="btn btn-primary order-1 order-sm-1 order-md-1 order-lg-1 order-xl-1 me-2" type="button" (click)="close()"><span translate>Button.Previous</span></button>
    </div>
    <div class="float-end">
        <button class="btn btn-success order-3 order-sm-3 order-md-3 order-lg-2 order-xl-2" type="button" (click)="save()"><span translate>Button.Save</span></button>
    </div>
</div>
